import Component from '@glimmer/component'
import type { TOC } from '@ember/component/template-only'
import { ResourcesListFile } from 'teacher-ui-client/components/teacher-toolkit/resources-list/file'
import { ResourcesListActivity } from 'teacher-ui-client/components/teacher-toolkit/resources-list/activity'
import {
  isTypeTeacherResourceActivity,
  isTypeTeacherResourceFiles,
} from 'teacher-ui-client/contentful-client/entry-types'
import {
  type TeacherResourceActivitySkeleton,
  type TeacherResourceFilesSkeleton,
} from 'teacher-ui-client/contentful-client/entry-types'
import type { Entry } from 'contentful'

export type Resource = Entry<
  TeacherResourceActivitySkeleton | TeacherResourceFilesSkeleton,
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>

interface Signature {
  Element: HTMLUListElement
  Args: { resources: Resource[] }
}

export const TeacherToolkitResourcesList: TOC<Signature> = <template>
  <ul class="md:columns-2 md:gap-x-8 lg:columns-3" ...attributes>
    {{#each @resources as |resource|}}
      <ResourceItem @resource={{resource}} />
    {{/each}}
  </ul>
</template>

class ResourceItem extends Component<{ Args: { resource: Resource } }> {
  get resourceFiles() {
    return isTypeTeacherResourceFiles(this.args.resource) ? this.args.resource.fields.files : []
  }

  get resourceActivity() {
    return isTypeTeacherResourceActivity(this.args.resource) ? this.args.resource : undefined
  }

  <template>
    {{#each this.resourceFiles as |asset|}}
      {{#if asset}}
        <li class="mb-1 break-inside-avoid-column py-2 leading-relaxed">
          <ResourcesListFile @asset={{asset}} />
        </li>
      {{/if}}
    {{/each}}
    {{#if this.resourceActivity}}
      <li class="mb-1 break-inside-avoid-column py-2 leading-relaxed">
        <ResourcesListActivity @resource={{this.resourceActivity}} />
      </li>
    {{/if}}
  </template>
}

export default TeacherToolkitResourcesList
